export default "__VITE_ASSET__ByRk3$ID__"